module.exports = __webpack_public_path__ + "static/media/video-play.a360c191.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shared/video-play.svg
// module id = 141
// module chunks = 0